module.exports = __webpack_public_path__ + "img/room6.ccaf885a.png";